<template>
  <div class="d-flex flex-column flex-lg-row min-vh-100 bg-light">
    <Sidebar
      :class="{ 'd-none d-lg-flex': !sidebarOpen }"
      @close-sidebar="sidebarOpen = false"
    />

    <div class="main-content">
      <Header @toggle-sidebar="sidebarOpen = !sidebarOpen" />

      <main class="container-fluid p-4">
        <!-- ERROR -->
        <div
          v-if="error"
          class="alert alert-danger alert-dismissible fade show"
        >
          {{ error }}

          <button
            type="button"
            class="btn-close"
            @click="error = null"
          ></button>
        </div>

        <!-- CONTENIDO -->
        <!--
          El módulo se dibuja de inmediato: encabezado, filtros y encabezado de
          la tabla. El estado de carga vive solo dentro del tbody, así al
          entrar o al cambiar de página no se vuelve a montar toda la pantalla.
        -->
        <div
          v-if="!permisos || permisos?.listar"
          class="proveedores-container"
        >
          <div class="proveedores-header">
            <div>
              <h2>Gestión de Proveedores</h2>

              <p>
                Listado general de proveedores registrados
              </p>
            </div>

            <!-- PERMISO CREAR -->
            <button
              v-if="permisos?.crear"
              type="button"
              class="btn-nuevo"
              @click="openAddModal"
            >
              Nuevo Proveedor
            </button>
          </div>

          <!-- FILTROS (se consultan contra la base de datos) -->
          <div class="proveedores-filtros">
            <div class="filtro-campo">
              <label>Nombre</label>

              <input
                v-model.trim="filtroNombre"
                type="text"
                placeholder="Ej. Distribuidora"
                @keyup.enter="aplicarFiltros"
              />
            </div>

            <div class="filtro-campo">
              <label>RFC</label>

              <input
                v-model.trim="filtroRfc"
                type="text"
                placeholder="Ej. PRB010101"
                @keyup.enter="aplicarFiltros"
              />
            </div>

            <div class="filtro-campo">
              <label>Creado desde</label>

              <input
                v-model="filtroDesde"
                type="date"
              />
            </div>

            <div class="filtro-campo">
              <label>Creado hasta</label>

              <input
                v-model="filtroHasta"
                type="date"
              />
            </div>

            <div class="filtro-acciones">
              <button
                type="button"
                class="btn-filtro btn-filtro-primario"
                :disabled="loading"
                @click="aplicarFiltros"
              >
                Buscar
              </button>

              <button
                type="button"
                class="btn-filtro"
                :disabled="loading"
                @click="limpiarFiltros"
              >
                Limpiar
              </button>
            </div>
          </div>

          <div class="proveedores-content">
            <div class="table-responsive">
              <table
                class="proveedores-table"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nombre</th>
                    <th>RFC</th>
                    <th>Teléfono</th>
                    <th>Email</th>
                    <th>Dirección</th>
                    <th>Fecha de creación</th>

                    <!-- COLUMNA ACCIONES -->
                    <th
                      v-if="
                        permisos?.actualizar ||
                        permisos?.eliminar
                      "
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <!-- CARGANDO: solo el cuerpo de la tabla -->
                  <tr v-if="loading">
                    <td
                      :colspan="totalColumnas"
                      class="text-center text-muted py-5"
                    >
                      <span
                        class="spinner-border spinner-border-sm me-2"
                      ></span>

                      Cargando proveedores...
                    </td>
                  </tr>

                  <template v-else>
                    <tr
                      v-for="(prov, index) in Proveedores"
                      :key="prov.id"
                    >
                      <td>
                        {{ numeroFila(index) }}
                      </td>

                      <td>
                        {{ prov.nombre }}
                      </td>

                      <td>
                        {{ prov.rfc }}
                      </td>

                      <td>
                        {{ prov.telefono }}
                      </td>

                      <td>
                        {{ prov.email }}
                      </td>

                      <td>
                        {{ prov.direccion }}
                      </td>

                      <td>
                        {{ fechaCreacion(prov) }}
                      </td>

                      <!-- ACCIONES -->
                      <td
                        v-if="
                          permisos?.actualizar ||
                          permisos?.eliminar
                        "
                      >
                        <!-- PERMISO ACTUALIZAR -->
                        <button
                          v-if="permisos?.actualizar"
                          type="button"
                          class="btn btn-sm btn-warning me-2"
                          @click="openEditModal(prov)"
                        >
                          <i class="bi bi-pencil"></i>
                        </button>

                        <!-- PERMISO ELIMINAR -->
                        <button
                          v-if="permisos?.eliminar"
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click="deleteProveedor(prov.id)"
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>

                    <tr v-if="Proveedores.length === 0">
                      <td
                        :colspan="totalColumnas"
                        class="text-center text-muted py-5"
                      >
                        {{
                          hayFiltros
                            ? 'Con esos filtros no hay resultados.'
                            : 'No hay proveedores registrados'
                        }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <!--
              PAGINACIÓN: cada botón dispara una consulta nueva al API.
              El navegador solo conserva la página actual.
            -->
            <div class="tabla-paginacion">
              <small>
                Mostrando {{ Proveedores.length }} de
                {{ meta.total }} &middot;
                Página {{ meta.current_page }} de
                {{ meta.last_page }}
              </small>

              <div class="paginacion-botones">
                <button
                  type="button"
                  class="btn-filtro"
                  :disabled="loading || meta.current_page <= 1"
                  @click="irPagina(meta.current_page - 1)"
                >
                  &lsaquo; Anterior
                </button>

                <button
                  type="button"
                  class="btn-filtro"
                  :disabled="
                    loading ||
                    meta.current_page >= meta.last_page
                  "
                  @click="irPagina(meta.current_page + 1)"
                >
                  Siguiente &rsaquo;
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- SIN PERMISO PARA LISTAR -->
        <div
          v-if="permisos && !permisos?.listar"
          class="alert alert-warning text-center"
        >
          No tienes permiso para ver los proveedores.
        </div>
      </main>
    </div>

    <!-- OVERLAY MÓVIL -->
    <div
      v-if="sidebarOpen"
      class="sidebar-overlay d-lg-none"
      @click="sidebarOpen = false"
    ></div>

    <!-- MODAL CREAR/EDITAR -->
    <BaseModal
      v-model:visible="modalVisible"
      :title="modalTitle"
    >
      <div class="mb-3">
        <label class="form-label">
          Nombre
        </label>

        <input
          v-model="ProveedorNombre"
          type="text"
          class="form-control"
          placeholder="Nombre del proveedor"
        />
      </div>

      <div class="mb-3">
        <label class="form-label">
          RFC
        </label>

        <input
          v-model="ProveedorRFC"
          type="text"
          class="form-control"
          placeholder="RFC"
        />
      </div>

      <div class="mb-3">
        <label class="form-label">
          Teléfono
        </label>

        <input
          v-model="ProveedorTelefono"
          type="text"
          class="form-control"
          placeholder="Teléfono"
        />
      </div>

      <div class="mb-3">
        <label class="form-label">
          Email
        </label>

        <input
          v-model="ProveedorEmail"
          type="email"
          class="form-control"
          placeholder="Correo electrónico"
        />
      </div>

      <div class="mb-3">
        <label class="form-label">
          Dirección
        </label>

        <input
          v-model="ProveedorDireccion"
          type="text"
          class="form-control"
          placeholder="Dirección"
        />
      </div>

      <template #footer>
        <button
          type="button"
          class="btn btn-secondary"
          @click="modalVisible = false"
        >
          Cancelar
        </button>

        <button
          v-if="
            editingId
              ? permisos?.actualizar
              : permisos?.crear
          "
          type="button"
          class="btn btn-primary"
          :disabled="loading"
          @click="saveProveedor"
        >
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm me-2"
          ></span>

          {{ editingId ? 'Actualizar' : 'Guardar' }}
        </button>
      </template>
    </BaseModal>

    <!-- MODAL DE CONFIRMACIÓN -->
    <ConfirmModal
      v-model:visible="confirmModalVisible"
      :message="confirmMessage"
      @confirmed="onConfirmDelete"
    />
  </div>
</template>

<script>
import {
  ref,
  computed,
  onMounted,
  onBeforeUnmount
} from 'vue';

import api, {
  obtenerPermisosPorModulo
} from '@/services/api.js';

import Header from '@/components/HeaderVue.vue';
import Sidebar from '@/components/Sidebar.vue';
import BaseModal from '@/components/BaseModal.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import { useFormatters } from '@/composables/useFormatters.js';


export default {
  name: 'ProveedoresViews',

  components: {
    Header,
    Sidebar,
    BaseModal,
    ConfirmModal
  },

  setup() {
    const sidebarOpen = ref(false);

    const Proveedores = ref([]);
    const loading = ref(false);
    const error = ref(null);

    const modalVisible = ref(false);
    const modalTitle = ref('');

    const ProveedorNombre = ref('');
    const ProveedorRFC = ref('');
    const ProveedorTelefono = ref('');
    const ProveedorEmail = ref('');
    const ProveedorDireccion = ref('');

    const editingId = ref(null);

    const confirmModalVisible = ref(false);
    const confirmMessage = ref('');
    const deletingId = ref(null);

    /*
     * null significa que los permisos aún no cargan.
     */
    const permisos = ref(null);

    const {
      formatDate
    } = useFormatters();
    /*
    |--------------------------------------------------------------------------
    | Filtros y paginación (se resuelven en el servidor)
    |--------------------------------------------------------------------------
    */
    const filtroNombre = ref('');
    const filtroRfc = ref('');
    const filtroDesde = ref('');
    const filtroHasta = ref('');

    const pagina = ref(1);

    // El módulo trabaja de 5 en 5.
    const porPagina = 5;

    const meta = ref({
      total: 0,
      current_page: 1,
      per_page: porPagina,
      last_page: 1
    });

    /*
     * Identifica la petición en curso: si el usuario cambia de página o de
     * filtro antes de que responda la anterior, la respuesta vieja se descarta.
     */
    let peticionActual = 0;

    /*
     * Se separa de 'loading' para que guardar o eliminar no vacíe la tabla.
     */
    const guardando = ref(false);

    const hayFiltros = computed(() => {
      return !!(
        filtroNombre.value ||
        filtroRfc.value ||
        filtroDesde.value ||
        filtroHasta.value
      );
    });

    const totalColumnas = computed(() => {
      return permisos.value?.actualizar ||
        permisos.value?.eliminar
        ? 8
        : 7;
    });

    const numeroFila = (index) => {
      const pag = meta.value.current_page || 1;

      return (pag - 1) * porPagina + index + 1;
    };

    const fechaCreacion = (registro) => {
      const valor =
        registro?.created_at ||
        registro?.updated_at;

      if (!valor) {
        return '-';
      }

      return formatDate(valor);
    };


    const permisoActivo = (valor) => {
      return (
        valor === true ||
        valor === 1 ||
        valor === '1' ||
        valor === 'true'
      );
    };

    /*
    |--------------------------------------------------------------------------
    | Cargar permisos
    |--------------------------------------------------------------------------
    */
    const fetchPermisos = async () => {
      try {
        const respuesta =
          await obtenerPermisosPorModulo(
            'provedores'
          );

        permisos.value = {
          listar: permisoActivo(
            respuesta?.listar
          ),

          crear: permisoActivo(
            respuesta?.crear
          ),

          actualizar: permisoActivo(
            respuesta?.actualizar
          ),

          eliminar: permisoActivo(
            respuesta?.eliminar
          )
        };
      } catch (e) {
        permisos.value = {
          listar: false,
          crear: false,
          actualizar: false,
          eliminar: false
        };

        error.value =
          'No fue posible cargar los permisos de proveedores.';
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Cargar proveedores
    |--------------------------------------------------------------------------
    */
        const fetchProveedores = async () => {
      if (!permisos.value?.listar) {
        Proveedores.value = [];
        return;
      }

      const idPeticion = ++peticionActual;

      loading.value = true;
      error.value = null;

      try {
        const res = await api.get('/provedores', {
          params: {
            nombre: filtroNombre.value || undefined,
            rfc: filtroRfc.value || undefined,
            desde: filtroDesde.value || undefined,
            hasta: filtroHasta.value || undefined,
            page: pagina.value,
            per_page: porPagina
          }
        });

        // Llegó tarde: ya se pidió otra página u otro filtro.
        if (idPeticion !== peticionActual) {
          return;
        }

        Proveedores.value = res.data?.data || [];

        const metaRespuesta = res.data?.meta;

        if (metaRespuesta) {
          meta.value = metaRespuesta;
          pagina.value = metaRespuesta.current_page;
        } else {
          meta.value = {
            total: res.data?.total || 0,
            current_page: pagina.value,
            per_page: porPagina,
            last_page: 1
          };
        }
      } catch (e) {
        if (idPeticion !== peticionActual) {
          return;
        }

        Proveedores.value = [];

        error.value =
          'Error al cargar proveedores: ' +
          (
            e.response?.data?.message ||
            e.message
          );
      } finally {
        if (idPeticion === peticionActual) {
          loading.value = false;
        }
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Acciones de filtro y paginación
    |--------------------------------------------------------------------------
    | Todas vuelven a consultar la base de datos; nada se filtra en memoria.
    */
    const aplicarFiltros = () => {
      pagina.value = 1;
      fetchProveedores();
    };

    const limpiarFiltros = () => {
      filtroNombre.value = '';
      filtroRfc.value = '';
      filtroDesde.value = '';
      filtroHasta.value = '';
      pagina.value = 1;

      fetchProveedores();
    };

    const irPagina = (n) => {
      if (
        n < 1 ||
        n > (meta.value.last_page || 1) ||
        n === meta.value.current_page
      ) {
        return;
      }

      pagina.value = n;
      fetchProveedores();
    };

    /*
    |--------------------------------------------------------------------------
    | Abrir modal para crear
    |--------------------------------------------------------------------------
    */
    const openAddModal = () => {
      if (!permisos.value?.crear) {
        error.value =
          'No tienes permiso para crear proveedores.';

        return;
      }

      modalTitle.value =
        'Nuevo Proveedor';

      ProveedorNombre.value = '';
      ProveedorRFC.value = '';
      ProveedorTelefono.value = '';
      ProveedorEmail.value = '';
      ProveedorDireccion.value = '';

      editingId.value = null;
      modalVisible.value = true;
    };

    /*
    |--------------------------------------------------------------------------
    | Abrir modal para editar
    |--------------------------------------------------------------------------
    */
    const openEditModal = (prov) => {
      if (!permisos.value?.actualizar) {
        error.value =
          'No tienes permiso para actualizar proveedores.';

        return;
      }

      modalTitle.value =
        'Editar Proveedor';

      ProveedorNombre.value =
        prov.nombre || '';

      ProveedorRFC.value =
        prov.rfc || '';

      ProveedorTelefono.value =
        prov.telefono || '';

      ProveedorEmail.value =
        prov.email || '';

      ProveedorDireccion.value =
        prov.direccion || '';

      editingId.value = prov.id;
      modalVisible.value = true;
    };

    /*
    |--------------------------------------------------------------------------
    | Guardar o actualizar proveedor
    |--------------------------------------------------------------------------
    */
    const saveProveedor = async () => {
      if (
        editingId.value &&
        !permisos.value?.actualizar
      ) {
        error.value =
          'No tienes permiso para actualizar proveedores.';

        return;
      }

      if (
        !editingId.value &&
        !permisos.value?.crear
      ) {
        error.value =
          'No tienes permiso para crear proveedores.';

        return;
      }

      if (
        !ProveedorNombre.value.trim() ||
        !ProveedorRFC.value.trim()
      ) {
        error.value =
          'El nombre y el RFC son obligatorios.';

        return;
      }

      guardando.value = true;
      error.value = null;

      try {
        const payload = {
          nombre:
            ProveedorNombre.value.trim(),

          rfc:
            ProveedorRFC.value.trim(),

          telefono:
            ProveedorTelefono.value.trim(),

          email:
            ProveedorEmail.value.trim(),

          direccion:
            ProveedorDireccion.value.trim()
        };

        if (editingId.value) {
          await api.put(
            `/provedores/${editingId.value}`,
            payload
          );
        } else {
          await api.post(
            '/provedores',
            payload
          );
        }

        await fetchProveedores();

        modalVisible.value = false;
      } catch (e) {
        error.value =
          'Error al guardar proveedor: ' +
          (
            e.response?.data?.message ||
            e.message
          );
      } finally {
        guardando.value = false;
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Solicitar eliminación
    |--------------------------------------------------------------------------
    */
    const deleteProveedor = (id) => {
      if (!permisos.value?.eliminar) {
        error.value =
          'No tienes permiso para eliminar proveedores.';

        return;
      }

      deletingId.value = id;

      confirmMessage.value =
        '¿Seguro que deseas eliminar este proveedor?';

      confirmModalVisible.value = true;
    };

    /*
    |--------------------------------------------------------------------------
    | Confirmar eliminación
    |--------------------------------------------------------------------------
    */
    const onConfirmDelete = async () => {
      if (!permisos.value?.eliminar) {
        error.value =
          'No tienes permiso para eliminar proveedores.';

        confirmModalVisible.value = false;
        return;
      }

      if (!deletingId.value) {
        return;
      }

      guardando.value = true;
      error.value = null;

      try {
        await api.delete(
          `/provedores/${deletingId.value}`
        );

        await fetchProveedores();
      } catch (e) {
        error.value =
          'Error al eliminar proveedor: ' +
          (
            e.response?.data?.message ||
            e.message
          );
      } finally {
        guardando.value = false;
        deletingId.value = null;
        confirmModalVisible.value = false;
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Inicialización
    |--------------------------------------------------------------------------
    */
    onMounted(async () => {
      await fetchPermisos();

      if (permisos.value?.listar) {
        await fetchProveedores();
      }
    });

    /*
    |--------------------------------------------------------------------------
    | Salir del módulo: no dejar datos en memoria
    |--------------------------------------------------------------------------
    | Se descarta el listado y se invalida cualquier petición en vuelo para que
    | su respuesta no reviva el estado ya desmontado.
    */
    onBeforeUnmount(() => {
      peticionActual++;

      Proveedores.value = [];

      meta.value = {
        total: 0,
        current_page: 1,
        per_page: porPagina,
        last_page: 1
      };
    });

    return {
      sidebarOpen,

      Proveedores,
      loading,
      error,

      modalVisible,
      modalTitle,

      ProveedorNombre,
      ProveedorRFC,
      ProveedorTelefono,
      ProveedorEmail,
      ProveedorDireccion,

      editingId,

      confirmModalVisible,
      confirmMessage,

      permisos,

      filtroNombre,
      filtroRfc,
      filtroDesde,
      filtroHasta,
      meta,
      guardando,
      hayFiltros,
      totalColumnas,

      numeroFila,
      fechaCreacion,
      aplicarFiltros,
      limpiarFiltros,
      irPagina,

      openAddModal,
      openEditModal,
      saveProveedor,
      deleteProveedor,
      onConfirmDelete
    };
  }
};
</script>


<style scoped>
.main-content{
    flex:1;
    margin-top:60px;
    transition:margin-left .3s ease;
}

@media (min-width:992px){
    .main-content{
        margin-left:250px;
    }
}

.sidebar-overlay{
    position:fixed;
    inset:0;
    background:rgba(0,0,0,.5);
    z-index:1019;
}

main{
    min-height:calc(100vh - 60px);
}

/* CONTENEDOR */

.proveedores-container{
    width:100%;
    background:#fff;
    border-radius:24px;
    overflow:hidden;
    border:1px solid #edf0f5;
    box-shadow:0 15px 40px rgba(0,0,0,.05);
}

/* HEADER */

.proveedores-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding:28px;
    border-bottom:1px solid #edf0f5;
}

.proveedores-header h2{
    margin:0;
    font-size:24px;
    font-weight:700;
    color:#111827;
}

.proveedores-header p{
    margin-top:6px;
    color:#6b7280;
}

/* BOTON */

.btn-nuevo{
    border:none;
    background:#2563eb;
    color:white;
    padding:12px 22px;
    border-radius:14px;
    font-weight:600;
}

/* CONTENIDO */

.proveedores-content{
    padding:20px;
    overflow-x:auto;
}

/* TABLA */

.proveedores-table{
    width:100%;
    border-collapse:separate;
    border-spacing:0 12px;
}

.proveedores-table thead th{
    color:#64748b;
    font-size:13px;
    text-transform:uppercase;
    font-weight:700;
    padding:0 20px 10px;
    white-space:nowrap;
}

.proveedores-table tbody tr{
    background:#f8fafc;
}

.proveedores-table td{
    padding:18px 20px;
    white-space:nowrap;
}

.proveedores-table tbody tr td:first-child{
    border-radius:16px 0 0 16px;
}

.proveedores-table tbody tr td:last-child{
    border-radius:0 16px 16px 0;
}

.btn-warning{
    border:none;
    border-radius:12px;
}

.btn-danger{
    border:none;
    border-radius:12px;
}

/* DATATABLE */


/* FILTROS */

.proveedores-filtros{
  display:flex;
  flex-wrap:wrap;
  gap:16px;
  align-items:flex-end;
  padding:20px 28px 0;
}

.filtro-campo{
  display:flex;
  flex-direction:column;
  gap:6px;
}

.filtro-campo label{
  color:#64748b;
  font-size:12px;
  font-weight:700;
  text-transform:uppercase;
}

.filtro-campo input{
  border:1px solid #e2e8f0;
  border-radius:12px;
  padding:10px 14px;
  min-width:200px;
}

.filtro-campo input:focus{
  outline:none;
  border-color:#2563eb;
}

.filtro-acciones{
  display:flex;
  gap:10px;
}

.btn-filtro{
  border:1px solid #e2e8f0;
  background:white;
  color:#334155;
  padding:10px 18px;
  border-radius:12px;
  font-weight:600;
}

.btn-filtro:hover:not(:disabled){
  background:#f1f5f9;
}

.btn-filtro:disabled{
  opacity:.5;
}

.btn-filtro-primario{
  background:#2563eb;
  border-color:#2563eb;
  color:white;
}

.btn-filtro-primario:hover:not(:disabled){
  background:#1d4ed8;
}

/* PAGINACIÓN */

.tabla-paginacion{
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  align-items:center;
  gap:12px;
  padding-top:16px;
  border-top:1px solid #edf0f5;
  color:#64748b;
}

.paginacion-botones{
  display:flex;
  gap:10px;
}

@media (max-width:768px){
  .proveedores-filtros{
    padding:20px 20px 0;
  }

  .filtro-campo,
  .filtro-campo input{
    width:100%;
    min-width:0;
  }

  .filtro-acciones{
    width:100%;
  }

  .btn-filtro{
    flex:1;
  }
}


/* RESPONSIVE */

@media(max-width:768px){

    .proveedores-header{
        flex-direction:column;
        align-items:flex-start;
        gap:15px;
    }

    .btn-nuevo{
        width:100%;
    }

}
</style>
